module.exports = __webpack_public_path__ + "img/icon11.a1b39558.png";